import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { Modal, ModalHeader, ModalBody, Input, Button } from 'reactstrap'

import StarRatingComponent from 'react-star-rating-component'
import { sendFeedbackData, toggleFeedbackOverlay } from 'store/Course/actions'
import UserAvatar from 'assets/img/_default_avatar.png'

const Feedback = (props) => {
	let newArray
	newArray = props.feedbackData.length ? props.feedbackData : []
	if (newArray.length && newArray[newArray.length - 1].average_rating) {
		newArray.pop()
	}

	console.log(newArray, 'array in feedback')
	return (
		<div className='create-course-form-now'>
			{newArray &&
				newArray.map((singleFeedbackItem, index) => (
					<div className='feedback-row' key={index}>
						<div>
							<img src={UserAvatar} />
						</div>
						<div className='feedback-data'>
							<h3 className='feedback-user-name'>
								{singleFeedbackItem.first_name +
									' ' +
									singleFeedbackItem.last_name}
							</h3>
							<StarRatingComponent
								className='user-rating'
								name='name2'
								starCount={5}
								value={singleFeedbackItem.rating}
								editing={false}
							/>
							<p className='feedback-user-message'>
								{singleFeedbackItem.feedback}
							</p>
						</div>
					</div>
				))}
		</div>
	)
}

function FeedbackButton(props) {
	const [hoverRating, setHoverRating] = useState(0)
	const [rating, setRating] = useState(0)
	const [feedback, setFeedback] = useState('')
	const dispatch = useDispatch()

	useEffect(() => {
		if (props.selfCourseFeedbackData && props.selfCourseFeedbackData !== null) {
			setRating(props.selfCourseFeedbackData.rating)
			setFeedback(props.selfCourseFeedbackData.feedback)
		}
	}, [props.selfCourseFeedbackData])

	const onStarClick = (nextValue) => {
		if (props.selfCourseFeedbackData) {
			alert('You already gave your feedback for this course!')
		} else {
			setRating(nextValue)
		}
	}

	const onStarHover = (nextValue) => {
		setHoverRating(nextValue)
	}

	const language = props.language || {}

	return (
		<div className='give-feedback d-flex flex-column align-items-center'>
			<label>
				{props.selfCourseFeedbackData && !props.isFeedbackTextboxActive
					? 'Your review:'
					: 'Leave course review:'}
			</label>
			<StarRatingComponent
				name='name1'
				starCount={5}
				value={rating ? rating : hoverRating}
				onStarClick={onStarClick}
				onStarHover={onStarHover}
			/>

			{!props.selfCourseFeedbackData && props.isFeedbackTextboxActive ? (
				<div>
					<Input
						id='course-feedback'
						name='Course feedback'
						type='textarea'
						disabled={props.selfCourseFeedbackData}
						value={feedback}
						rows='3'
						onChange={(e) => setFeedback(e.target.value)}
						placeholder='Course feedback'
						style={{ resize: 'none' }}
					/>
					<Button
						color='info'
						type='submit'
						className='mt-3'
						disabled={props.selfCourseFeedbackData}
						onClick={() =>
							dispatch(sendFeedbackData(rating, feedback, props.course_id))
						}
					>
						{language.general ? language.general.share : null}
					</Button>
				</div>
			) : (
				<p>{feedback}</p>
			)}
		</div>
	)
}

const FeedbackOverlay = (props) => {
	const dispatch = useDispatch()

	return (
		<Modal
			size='xl'
			isOpen={props.isFeedbackOverlayShowing}
			toggle={() => dispatch(toggleFeedbackOverlay())}
			centered
		>
			<ModalHeader
				className='border-lighter border-bottom mb-0 d-flex align-items-center'
				toggle={() => dispatch(toggleFeedbackOverlay())}
			>
				Reviews
			</ModalHeader>
			<ModalBody>
				{props.access === 1 ? (
					<div className='row align-items-start'>
						<div className='col-md-6'>
							<Feedback {...props} />
						</div>
						<div className='col-md-6'>
							<FeedbackButton {...props} />
						</div>
					</div>
				) : (
					<div className='row'>
						<div className='col-md-12'>
							<FeedbackButton {...props} />
						</div>
					</div>
				)}
			</ModalBody>
		</Modal>
	)
}

export default FeedbackOverlay
